<script lang="ts">
  import { isActiveSubscription } from "../../helpers/subscription";
  import LargeButton from "../../components/buttons/LargeButton.svelte";
  import ProductCard from "./ProductCard.svelte";
  import TextNew from "../../components/TextNew.svelte";
  import CloseIcon from "../../components/icons/CloseIcon.svelte";
  import { createGetSubscriptionQuery } from "../../queries/subscriptions";
  import { selectedBuyer } from "../../stores/buyer";

  export let onContinue: () => void;
  export let onClose: () => void;

  $: buyerID = $selectedBuyer?.id ?? "";
  $: subscriptionQuery = createGetSubscriptionQuery(buyerID);
  $: isInvalidSubscription =
    ($subscriptionQuery.data && !isActiveSubscription($subscriptionQuery.data.status)) ||
    $subscriptionQuery.error;
</script>

<div class="container">
  <button class="close" on:click={onClose}><CloseIcon fill={"#FFFFFF99"} /></button>
  <div class="left">
    <TextNew size="xl" weight="medium">you’re in! upload your invoices to get started</TextNew>
    <div class="product">
      <ProductCard subtitle="30 days free" />
    </div>
    <div class="bullets">
      <div class="bullet">
        <div class="bullet-circle">
          <TextNew size="m" weight="medium" --rk-text-color="var(--rk-text-light)">1</TextNew>
        </div>
        <TextNew size="s">upload recent invoices from all your suppliers</TextNew>
      </div>
      <div class="bullet">
        <div class="bullet-circle">
          <TextNew size="m" weight="medium" --rk-text-color="var(--rk-text-light)">2</TextNew>
        </div>
        <TextNew size="s">REKKI takes care of all the processing</TextNew>
      </div>
      <div class="bullet">
        <div class="bullet-circle">
          <TextNew size="m" weight="medium" --rk-text-color="var(--rk-text-light)">3</TextNew>
        </div>
        <TextNew size="s">see a full overview of your spend and food costs</TextNew>
      </div>
    </div>
    <div class="footer">
      {#if isInvalidSubscription}
        <LargeButton color="neutral-02" disabled title="invalid subscription" onClick={() => {}} />
      {:else}
        <LargeButton title="get started" onClick={onContinue} />
      {/if}
    </div>
  </div>
  <div class="right">
    <img src="static/assets/premium-welcome.svg" alt="premium-welcome" />
  </div>
</div>

<style>
  .container {
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
    background-color: #ffffff;
    border-radius: 24px;
    position: relative;
    overflow: hidden;
    max-width: 944px;
    max-height: 600px;
  }
  .left,
  .right {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
    box-sizing: border-box;
    width: 50%;
  }

  .close {
    position: absolute;
    top: 16px;
    right: 16px;
  }

  .left {
    padding: 32px 24px 24px 24px;
  }

  .right img {
    width: 100%;
    height: 100%;
    display: block;
    object-fit: cover;
  }

  .product {
    margin-top: 16px;
    width: 100%;
  }

  .bullets {
    margin-top: 36px;
  }

  .bullet {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 20px;
  }

  .bullet-circle {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 40px;
    height: 40px;
    background-color: var(--rekki-neutral-04);
    font-size: 18px;
    color: white;
    border-radius: 20px;
    margin-right: 12px;
    padding-top: 5px;
  }

  .footer {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    flex-grow: 1;
    width: 100%;
  }
</style>
